module.exports = __webpack_public_path__ + "img/chesk.d648a8f7.png";